<template>
  <div class="honour-container" v-if="!loading">
    <div class="wrapper" ref="wrapper">
      <div class="honour-content">

        <template v-for="(value,index) in betterData" >
          <div class="group" :key="index" v-if="index % 2===0">

            <div class="column">
              <div class="pic" @click="openLightBox(value[0])">
                <img :src="resources[value[0].thumb].src"/>
              </div>
              <div class="pic" @click="openLightBox(value[1])">
                <img :src="resources[value[1].thumb].src"/>
              </div>
            </div>
            <div class="column">
              <div class="pic" @click="openLightBox(value[2])">
                <img :src="resources[value[2].thumb].src"/>
              </div>
            </div>
          </div>
          <div class="group" :key="index" v-else>
            <div class="column">
              <div class="pic" @click="openLightBox(value[0])">
                 <img :src="resources[value[0].thumb].src"/>
              </div>
            </div>
            <div class="column">
              <div class="pic" @click="openLightBox(value[1])">
                <img :src="resources[value[1].thumb].src"/>
              </div>
              <div class="pic" @click="openLightBox(value[2])">
                <img :src="resources[value[2].thumb].src"/>
              </div>
            </div>
           
          </div>
        </template>
        
      </div>
    </div>
    <Pagination class="pagination" :items="items" :curIndex.sync="curIndex"></Pagination>
  
    <transition name="fade">
      <LightBox :closed.sync="closed" class="light-box"  :data="data" >
        <template v-slot:left="{scope}">
          <div class="slide-main">
            <img :src="resources[scope.icon].src"/>
          </div>
        </template>
        <template v-slot:close>
          <img @click="closeLightBox" :src="resources['trainingDialogBtnClose'].src" class="btn-close"/>
        </template>
      </LightBox>
    </transition>
  
  
  </div>
  <div v-else>
    <i class="icon-loading"></i>
  </div>
</template>
<script>
import {userAgent} from 'ua_parser';
import {chunk} from "loadsh";
import works from "../api/honour.js";
import Pagination from "../components/Pagination.vue";
import Bscroll from '@better-scroll/core'
import MouseWheel from '@better-scroll/mouse-wheel'
Bscroll.use(MouseWheel)
var ua = userAgent(navigator.userAgent).browser ; 

import LightBox from  "../components/LightBox.vue";
import { format } from 'path';

export default {
  name:'Honour',
  components:{Pagination,LightBox},
  data() {
    return {
      loading:true,
      index:0,
      curIndex:0,
      scroll:null,
      items:[],
      resources:null,
      closed:true,
      data:{}
    }
  },
  computed:{
    betterData(){
      let dataArr = [];
      for(let medal  in works) {
        let {name,icon,sources} = works[medal];
        dataArr.push(...sources);
      }
      return chunk(dataArr,3);
    }
  },
  created(){
    let r = this.resources = this.$store.state.resources;
    for(let medal  in works) {
      let {name,icon,sources} = works[medal];
      this.items.push(name);
    
    }
    
  },
  watch:{
    loading(){
      if(this.scroll) return ;
      this.$nextTick(()=>{
        this.scroll = new Bscroll(this.$refs.wrapper, {
          scrollX:true,
          click:true,
          tap: 'tap',
          mouseWheel:true,
          probeType:3,
          disableMouse:false,
          bounce: {
            left:false,
            right:false
          }
        });
        if(ua.msie) {
          this.$refs.wrapper.classList.add('fixIE');
          console.log('移除元素');
        }
      })
      
    }
  },
  methods:{
    closeLightBox(){
      this.closed = true;
    },
    openLightBox(item){
      if(!item.zpic.length) return ;
      console.log(item);
      this.data = item;
      this.closed = false;
    }
  },
  
  mounted(){
    this.$nextTick(()=>{
      this.loading = false;
    })
  }
}
</script>
<style lang="scss" scoped>
  @import "../common/common.scss";
  .honour-content {
    display: inline-block;
    height: 100%;
  }
  .honour-navbar {
    position: absolute;
    left: 0;
    right: 0;
    margin: auto;
    text-align: center;
  }
  .wrapper {
    font-size: 0;
    width: 100%;
    position: absolute;
    top: 50%;
    left: 0;
    transform: translate3d(0,-50%,0);
    height: px2rem(734);
    padding: 40px 0;
    overflow: hidden;
    white-space: nowrap;
    &.fixIE {
      &:after{
        display: none;
      }
    }
    &:after {
      content: '';
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      background: linear-gradient(to left ,  #eeeeee 0%,transparent 20%);
      pointer-events: none;
    }
  }
  
  .group {
    display: inline-flex;
    flex-direction: column;
    vertical-align: text-top;
    height: 100%;
    width: px2rem(512);
    
    + .group {
      margin-left: px2rem(20);
    }
  }
  .column {
    
    flex: 1;
    display: flex;
    justify-content: space-between;
    width: 100%;
    + .column {
      margin-top:px2rem(20);
    }
    .pic {
      position: relative;
      overflow: hidden;
      flex: 1;
      font-size: 0;
      img {
        width: 100%;
        height: auto;
      }
      + .pic {
        margin-left:px2rem(20);
      }
    }
  }
  .pagination {
    text-align: center;
    position: absolute;
    left: 0;
    right: 0;
    margin: auto;
    bottom: px2rem(60);
    font-size: px2rem(18);
    line-height: 1.2;
  }
  .pic {
    cursor: pointer;
    transition: all .5s linear;
    &:hover {
      z-index: 999;
      transform: translate3d(0,0,0) scale(1.2);
      
    }
  }
  .icon-loading{
    background: url('<svg t="1564992006347" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2117" width="128" height="128"><path d="M782.065385 901.683615c10.892554 18.38743 4.796721 42.970626-14.290231 53.363521-18.687226 10.892554-42.470967 4.496926-53.063726-14.290232-11.392212-18.38743-4.796721-42.470967 13.690641-53.363521 19.386747-10.792622 42.770762-4.197131 53.663316 14.290232z m-230.342539 83.243095c0 21.285449-17.587977 39.07329-39.67288 39.07329-21.285449 0-39.07329-17.388114-39.07329-39.07329v-27.381282c0-21.785108 17.887772-39.173221 39.07329-39.173222 21.785108 0 39.67288 17.388114 39.67288 39.173222v27.381282z m-241.135162-44.169806c-11.092417 19.286816-35.175954 25.382649-53.663316 14.490095-18.987021-10.692691-25.682444-34.576364-14.490095-53.663316l29.080121-50.865229c11.192349-18.687226 35.175954-25.182785 54.162975-14.490094 18.38743 10.892554 25.182785 35.175954 13.990436 53.663316l-29.080121 50.865228zM123.415634 782.764907c-18.987021 10.592759-43.270421 4.197131-53.663316-14.490095-11.092417-18.38743-4.796721-42.770762 13.990436-53.663316l78.146579-45.269054c18.687226-10.392895 42.970626-4.496926 53.663317 14.490094 10.592759 18.38743 4.097199 42.770762-14.490095 53.663316l-77.646921 45.269055zM40.27247 551.822777c-21.785108 0-39.07329-17.587977-39.07329-39.073289 0-21.785108 17.288182-39.373085 39.07329-39.373085h121.716795c21.785108 0 39.07329 17.587977 39.07329 39.07329 0 21.785108-17.288182 39.373085-39.07329 39.373084H40.27247z m43.570216-241.534888c-18.987021-10.592759-25.182785-34.576364-13.990437-53.363521 10.392895-18.987021 34.576364-25.382649 53.663317-14.490095L255.82512 319.281741c18.687226 10.692691 24.88299 34.576364 14.490094 53.063726-11.092417 18.987021-35.175954 25.082854-53.563384 14.490095l-132.909144-76.547673z m158.591587-187.072119l92.137016 159.990632c11.192349 18.687226 35.175954 25.382649 53.86318 14.290231 18.687226-10.592759 24.88299-34.876159 13.990436-53.663316L309.888162 84.142481C299.295404 65.655119 275.311799 58.959696 256.824436 69.852249c-18.987021 10.892554-25.082854 34.976091-14.390163 53.363521z m230.642335-82.643505c0-21.285449 17.887772-39.373085 39.07329-39.373085 21.785108 0 39.67288 17.687909 39.672879 39.373085V224.846296c0 21.785108-17.587977 39.373085-39.672879 39.67288-21.285449 0-39.07329-17.288182-39.07329-39.67288V40.572265z m241.135161 43.570216c11.192349-18.987021 34.876159-25.182785 53.663316-14.490095 18.987021 10.592759 25.682444 34.576364 14.490095 53.663316l-92.336879 159.990632c-10.392895 18.687226-34.976091 25.282717-53.663316 14.490094-18.687226-10.892554-24.88299-35.175954-14.290231-53.963111l92.137015-159.690836z m187.671709 158.291792L741.692983 334.771153c-18.687226 10.592759-25.182785 34.576364-14.490094 53.663316 11.092417 18.38743 35.175954 24.583195 53.663316 14.290231l160.290426-92.336879c18.38743-10.592759 25.182785-34.576364 13.990436-53.363521-10.792622-18.987021-34.876159-25.782375-53.263589-14.590027z m82.34371 230.94213c21.984971 0 39.373085 17.587977 39.07329 39.373085 0 21.485313-16.988387 39.07329-39.07329 39.073289H799.753294c-21.285449 0-39.173221-17.587977-39.173222-39.373084 0-21.485313 17.887772-39.07329 39.173222-39.07329h184.473894z" fill="#999999" p-id="2118"></path></svg>');
  }
  .btn-close {
    position: absolute;
    right: 0;
    top: 0;
    cursor: pointer;
  }

  /deep/ .light-box .left-wrapper {
    width: px2rem(346);
    .slide-main {
      width: 100%;
    }
    .swiper-slide {
      display: flex;
      align-items: center;
    }
    img {
      max-width: 100%;
      height: auto;
    }
  }

  
 
</style>
